import RelatedExampleEditing from './related-example-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class RelatedExampleUI extends Plugin {
    init() { }
}
export default class RelatedExample extends Plugin {
    static get requires() {
        return [RelatedExampleEditing, RelatedExampleUI];
    }
}
